import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from 'src/app/interfaces/api-response';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class SuperAdminService {

    constructor(private http: HttpClient) { }

    getPs() : Observable<ApiResponse> {
        return this.http.get<ApiResponse>(environment.appApiUrl + "admin/getPs");
    }

    getClient(): Observable<ApiResponse> {
        return this.http.get<ApiResponse>(environment.appApiUrl + "admin/getClients");
    }

    async loadPS(info: any, filename: string): Promise<ApiResponse> {
        const body = {'info' : info, 'filename': filename};
        return this.http.post<ApiResponse>(environment.appApiUrl + "admin/loadPS", body).toPromise();
    }

    addPs(psInfo: any) : Observable<ApiResponse> {
        psInfo = this.prepareResponsable(psInfo);
        return this.http.put<ApiResponse>(environment.appApiUrl + "admin/addPS" , psInfo);
    }

    resetPassword(ps_id: string): Observable<ApiResponse> {
        return this.http.post<ApiResponse>(environment.appApiUrl + "admin/passwordReset/" + ps_id, null);
    }

    updatePS(psInfo: any) : Observable<ApiResponse> {
        psInfo = this.prepareResponsable(psInfo);
        return this.http.post<ApiResponse>(environment.appApiUrl + "admin/updatePS" , psInfo);
    }

    getClientInfo(client_id: string) : Observable<ApiResponse> {
        return this.http.get<ApiResponse>(environment.appApiUrl + "admin/clientInfo/" + client_id);
    }

    updateClient(clientInfo: any) : Observable<ApiResponse> {
        return this.http.post<ApiResponse>(environment.appApiUrl + "admin/updateClient" , clientInfo);
    }

    addClient(clientInfo: any) : Observable<ApiResponse> {
        return this.http.put<ApiResponse>(environment.appApiUrl + "admin/addClient" , clientInfo);
    }

    async loadClient(info: any, filename: string): Promise<ApiResponse> {
        const body = {'info' : info, 'filename': filename};
        return this.http.post<ApiResponse>(environment.appApiUrl + "admin/loadClient", body).toPromise();
    }

    private prepareResponsable(psValue: any) {

        if (psValue.responsable == 'false' || psValue.responsable == 'undefined') {
            psValue.responsable = false;
            psValue.res_email = '';
            psValue.res_identifiant = '';
            psValue.res_description = '';
        } else {
            psValue.responsable = true;
        }

        return psValue;
    }
}
